<template>
  <auth-layout>
    <v-card class="auth-base elevation-12" width="300px">
      <v-card-title class="mt-3">
        <img
          width="120px"
          height="80px"
          class="mx-auto"
          src="@/assets/pixel-logo-1.svg"
          :key="1"
          alt
          v-if="$vuetify.theme.dark"
        />
        <img
          width="120px"
          height="80px"
          class="mx-auto"
          src="@/assets/pixel-logo-2.svg"
          :key="2"
          alt
          v-else
        />
      </v-card-title>
      <v-card-text class="text-center">
        Entering to app...
      </v-card-text>
      <v-card-text class="text-center pt-0 pb-6">
        <v-progress-circular
          class="mt-2"
          size="30"
          width="2"
          indeterminate
          color="primary"
          :distance="10"
        />
      </v-card-text>
    </v-card>
  </auth-layout>
</template>
<script>
import AuthLayout from './AuthLayout';
import { onMounted } from '@vue/composition-api';
import useAuth from '@/api/auth';
import { loadLanguageAsync } from '@/i18n-setup';

import router from '@/router';

export default {
  name: 'LoginFromApp',
  components: { AuthLayout },
  setup(props, context) {
    const { user, loginFromApp } = useAuth();

    onMounted(async () => {
      if (user.value?.id) {
        router.push({ name: 'devices' });
      } else {
        const params = new URLSearchParams(window.location.search.substring(1));

        if (params.get('token')) {
          localStorage.setItem('refreshToken', params.get('token'));
          localStorage.setItem('tokenId', params.get('tokenId'));

          loginFromApp()
            .then(() => {
              context.root.$router.push('/');
              loadLanguageAsync();
            })
            .catch(() => {
              context.root.$router.push('/login');
            });
        }
      }
    });
  }
};
</script>
